module.exports = __webpack_public_path__ + "img/Vy Tran.b985f09c.jpg";